// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SecurityDashboard.css — pestaña «Seguridad» del inicio. Tokens del tema. */

.sd-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
}

.sd-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.sd-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.sd-subtitle {
  margin: 2px 0 0;
  font-size: 0.84rem;
  color: var(--text-secondary);
}

.sd-error {
  color: var(--danger, #ef4444);
  margin: 0;
}

.sd-hero {
  display: flex;
  gap: 22px;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px 22px;
  border-radius: var(--radius-lg, 16px);
  border: 1px solid var(--border);
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(var(--accent-rgb, 59, 130, 246), 0.18), transparent 60%),
    var(--bg-surface);
}

.sd-ring-value {
  font-size: 1.9rem;
  font-weight: 800;
  fill: var(--text-primary);
}

.sd-ring-label {
  font-size: 0.7rem;
  fill: var(--text-muted);
}

.sd-hero-text h3 {
  margin: 0 0 4px;
  font-size: 1.1rem;
}

.sd-hero-text p {
  margin: 0 0 10px;
  font-size: 0.86rem;
  color: var(--text-secondary);
  max-width: 60ch;
}

.sd-hero-chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.sd-hero-chips .list-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.sd-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.sd-risk {
  display: flex;
  gap: 12px;
  align-items: center;
  text-align: left;
  padding: 14px 16px;
  border-radius: var(--radius-md, 12px);
  border: 1px solid var(--border);
  background: var(--bg-surface);
  color: var(--text-primary);
  cursor: pointer;
  transition: transform 0.12s ease, border-color 0.12s ease;
}

.sd-risk:hover {
  transform: translateY(-1px);
  border-color: var(--accent);
}

.sd-risk-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(var(--accent-rgb, 59, 130, 246), 0.12);
  color: var(--accent-l);
  flex: 0 0 auto;
}

.sd-risk--warn .sd-risk-icon {
  background: rgba(245, 158, 11, 0.14);
  color: var(--warn, #f59e0b);
}

.sd-risk--bad .sd-risk-icon {
  background: rgba(239, 68, 68, 0.14);
  color: var(--danger, #ef4444);
}

.sd-risk--ok .sd-risk-icon {
  background: rgba(34, 197, 94, 0.14);
  color: var(--success, #22c55e);
}

.sd-risk-body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.sd-risk-value {
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1.05;
}

.sd-risk-title {
  font-size: 0.8rem;
  font-weight: 600;
}

.sd-risk-detail {
  font-size: 0.72rem;
  color: var(--text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sd-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 12px;
}

.sd-card {
  border: 1px solid var(--border);
  border-radius: var(--radius-md, 12px);
  background: var(--bg-surface);
  padding: 14px 16px;
}

.sd-card h4 {
  margin: 0 0 10px;
  font-size: 0.9rem;
}

.sd-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 6px 0;
  border-top: 1px solid var(--border);
  font-size: 0.84rem;
}

.sd-row-value {
  margin-left: auto;
  font-weight: 700;
}

.sd-actions {
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 0.84rem;
  color: var(--text-secondary);
}

.sd-foot {
  margin: 0;
}

.sd-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 48px 0;
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/SecurityDashboard.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B;;qBAEmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B","sourcesContent":["/* SecurityDashboard.css — pestaña «Seguridad» del inicio. Tokens del tema. */\r\n\r\n.sd-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  padding-bottom: 24px;\r\n}\r\n\r\n.sd-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.sd-title {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.sd-subtitle {\r\n  margin: 2px 0 0;\r\n  font-size: 0.84rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sd-error {\r\n  color: var(--danger, #ef4444);\r\n  margin: 0;\r\n}\r\n\r\n.sd-hero {\r\n  display: flex;\r\n  gap: 22px;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  padding: 20px 22px;\r\n  border-radius: var(--radius-lg, 16px);\r\n  border: 1px solid var(--border);\r\n  background:\r\n    radial-gradient(120% 140% at 0% 0%, rgba(var(--accent-rgb, 59, 130, 246), 0.18), transparent 60%),\r\n    var(--bg-surface);\r\n}\r\n\r\n.sd-ring-value {\r\n  font-size: 1.9rem;\r\n  font-weight: 800;\r\n  fill: var(--text-primary);\r\n}\r\n\r\n.sd-ring-label {\r\n  font-size: 0.7rem;\r\n  fill: var(--text-muted);\r\n}\r\n\r\n.sd-hero-text h3 {\r\n  margin: 0 0 4px;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.sd-hero-text p {\r\n  margin: 0 0 10px;\r\n  font-size: 0.86rem;\r\n  color: var(--text-secondary);\r\n  max-width: 60ch;\r\n}\r\n\r\n.sd-hero-chips {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.sd-hero-chips .list-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.sd-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.sd-risk {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n  text-align: left;\r\n  padding: 14px 16px;\r\n  border-radius: var(--radius-md, 12px);\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-surface);\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  transition: transform 0.12s ease, border-color 0.12s ease;\r\n}\r\n\r\n.sd-risk:hover {\r\n  transform: translateY(-1px);\r\n  border-color: var(--accent);\r\n}\r\n\r\n.sd-risk-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 12px;\r\n  background: rgba(var(--accent-rgb, 59, 130, 246), 0.12);\r\n  color: var(--accent-l);\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.sd-risk--warn .sd-risk-icon {\r\n  background: rgba(245, 158, 11, 0.14);\r\n  color: var(--warn, #f59e0b);\r\n}\r\n\r\n.sd-risk--bad .sd-risk-icon {\r\n  background: rgba(239, 68, 68, 0.14);\r\n  color: var(--danger, #ef4444);\r\n}\r\n\r\n.sd-risk--ok .sd-risk-icon {\r\n  background: rgba(34, 197, 94, 0.14);\r\n  color: var(--success, #22c55e);\r\n}\r\n\r\n.sd-risk-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.sd-risk-value {\r\n  font-size: 1.5rem;\r\n  font-weight: 800;\r\n  line-height: 1.05;\r\n}\r\n\r\n.sd-risk-title {\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.sd-risk-detail {\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.sd-columns {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.sd-card {\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-md, 12px);\r\n  background: var(--bg-surface);\r\n  padding: 14px 16px;\r\n}\r\n\r\n.sd-card h4 {\r\n  margin: 0 0 10px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.sd-row {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n  padding: 6px 0;\r\n  border-top: 1px solid var(--border);\r\n  font-size: 0.84rem;\r\n}\r\n\r\n.sd-row-value {\r\n  margin-left: auto;\r\n  font-weight: 700;\r\n}\r\n\r\n.sd-actions {\r\n  margin: 0;\r\n  padding-left: 18px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n  font-size: 0.84rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sd-foot {\r\n  margin: 0;\r\n}\r\n\r\n.sd-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 48px 0;\r\n  color: var(--text-secondary);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
